<template>
  <el-select
    v-model="mySelectedValue"
    :placeholder="placeholder"
    :disabled="disabled"
    clearable
    filterable
  >
    <el-option
      v-for="option in Option"
      :key="option.value"
      :label="option.name"
      :value="option.value"
    />
  </el-select>
</template>

<script>
// 字典数据表 下拉框组件
import { getDictOptions } from '@/api/sys/dictionary'

export default {
  name: 'Dictionary',
  // 接受父组件传递的消息
  props: {
    /**
     * 字典类型编码(eg: 性别-gender)
     */
    typeCode: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [String, Number],
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      mySelectedValue: '',
      Option: []
    }
  },
  watch: {
    // 监听父组件传入的数据，更新到本地
    modelValue(newVal) {
      if (newVal != '' && undefined != newVal) {
        this.mySelectedValue = newVal;
      } else {
        this.mySelectedValue = ''
      }
    },
    // myCompanyId 修改后通知 父级模块
    mySelectedValue(newVal) {
      this.$emit('change', newVal)
    }
  },
  mounted() {
    if (this.modelValue != '' && undefined != this.modelValue) {
        this.mySelectedValue = this.modelValue;
    }
    this._getDictOptionsList()
  },
  methods: {
    _getDictOptionsList() {
      getDictOptions(this.typeCode).then(response => {
        this.Option = []
        this.Option.push({ value: "", name: this.placeholder })
        this.Option.push(...response.data)
      })
    }
  }
}
</script>
